import React from 'react'
import './ChangePassword.css'
import { useHistory } from 'react-router-dom'
import { Grid } from '@material-ui/core'
import ChevronRightOutlinedIcon from '@mui/icons-material/ChevronRightOutlined'

const ChangePassword = (props) => {
    const history = useHistory()
    return (
        <div className="edit-info-page-container">
            <Grid container direction="row" alignItems="center" spacing={1}>
                <span
                    className="firstStep"
                    onClick={() => history.push('/my-account')}
                >
                    My Account
                </span>
                <ChevronRightOutlinedIcon />
                <span className="secondStep">Change Password</span>
            </Grid>
        </div>
    )
}

export default ChangePassword
